// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"aa3600773fe4682a","731":"3bd8868cbd53235a","777":"167cdd5b6888733d"}[chunkId] + ".js";
};